import { render, staticRenderFns } from "./Percentiles.vue?vue&type=template&id=bf3c4042&scoped=true&"
import script from "./Percentiles.vue?vue&type=script&lang=js&"
export * from "./Percentiles.vue?vue&type=script&lang=js&"
import style0 from "./Percentiles.vue?vue&type=style&index=0&id=bf3c4042&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3c4042",
  null
  
)

export default component.exports